"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transact = void 0;
const eosjs_1 = require("eosjs");
const config_1 = require("./config");
/**
 * Push transaction on EOSIO
 */
function transact(actions, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const blocksBehind = options.blocksBehind ? options.blocksBehind : 3;
        const expireSeconds = options.expireSeconds ? options.expireSeconds : 30;
        try {
            const result = yield config_1.settings.api.transact({ actions }, { blocksBehind, expireSeconds });
            return result.transaction_id;
        }
        catch (e) {
            if (e instanceof eosjs_1.RpcError) {
                throw new Error(JSON.stringify(e.json, null, 2));
            }
            else {
                throw new Error(e);
            }
        }
    });
}
exports.transact = transact;
//# sourceMappingURL=eosio.js.map